export default {
  name: 'sinisterhistorydetails',
  props: {
    previousObject: {
      type: [String],
      default: ''
    },
    newObject: {
      type: [String],
      default: ''
    }
  },
  computed: {
    OriginalValues () {
      if (this.previousObject !== '' && this.previousObject !== null) {
        return this.outputPrettythis(this.previousObject)
      } else {
        return ''
      }
    },
    NewValues () {
      if (this.newObject !== '' && this.newObject !== null) {
        return this.outputPrettythis(this.newObject)
      } else {
        return ''
      }
    }
  },
  methods: {
    output (inp) {
      // document.body.appendChild(document.createElement('pre')).innerHTML = inp
      return ''
    },
    outputPretty: function (jsonstring) {
      var pretty = JSON.parse(jsonstring)
      return this.syntaxHighlight(pretty)
    },
    syntaxHighlight (json) {
      if (typeof json !== 'string') {
        json = JSON.stringify(json, undefined, 2)
      }

      json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[+\][eE]?\d+)?)/g, function (match) {
        var cls = 'number'
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'key'
          } else {
            cls = 'string'
          }
        } else if (/true|false/.test(match)) {
          cls = 'boolean'
        } else if (/null/.test(match)) {
          cls = 'null'
        }
        return '<span class="' + cls + '">' + match + '</span>'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/history/sinisterhistorydetails.js